import { TFunction } from 'i18next';

const statusCodes = {
  fixed: '0',
  open: '1',
  workingOnIt: '2',
  needsContext: '3',
  nonIssue: '9',
};

export const bugReportStatuses = {
  fixed: {
    code: statusCodes.fixed,
    getLabel: (t: TFunction) => t('fixed'),
    color: '#00D39D',

    statusTargets: [] as string[],
  },

  open: {
    code: statusCodes.open,
    getLabel: (t: TFunction) => t('open'),
    color: '#F3003A',

    statusTargets: [
      statusCodes.fixed,
      statusCodes.nonIssue,
      statusCodes.needsContext,
      statusCodes.workingOnIt,
    ],
  },

  workingOnIt: {
    code: statusCodes.workingOnIt,
    getLabel: (t: TFunction) => t('workingOnIt'),
    color: '#1560CE',

    statusTargets: [statusCodes.fixed, statusCodes.nonIssue],
  },

  needsContext: {
    code: statusCodes.needsContext,
    getLabel: (t: TFunction) => t('needsContext'),
    color: '#FFBF00',

    statusTargets: [statusCodes.fixed, statusCodes.nonIssue],
  },

  nonIssue: {
    code: statusCodes.nonIssue,
    getLabel: (t: TFunction) => t('nonIssue'),
    color: '#C4C4C4',

    statusTargets: [] as string[],
  },
};

export const bugReportByCode = Object.fromEntries(
  Object.values(bugReportStatuses).map((c) => [c.code, c]),
);
